import { makeThemedStyles } from "qpr-base/viewcomponents/utils";

const useTabsStyles = makeThemedStyles("Toolbars.Tabs", (theme) => ({
  root: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "26px",
    height: "34px",
    maxWidth: "400px",
    minHeight: "22px !important",
    color: "rgb(148, 143, 143)",
    textTransform: "unset",
    marginTop: "13px",
    padding: "0px 2px 0px 2px",
  },
  indicator: {
    display: "none",
  },
}));

const useTabStyles = makeThemedStyles("Toolbars.Tabs", (theme) => ({
  root: {
    height: "24px",
    justifySelf: "center",
    alignSelf: "center",
    fontSize: "12px",
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "1px",
    lineHeight: "22px",
    minHeight: "22px",
    color: "rgba(0, 0, 0, 0.6 )",
    padding: "0px 15px 0px 15px",
  },
  selected: {
    zIndex: 1,
    color: "#fff",
    backgroundColor: "rgb(0,100,216)",
    borderRadius: "26px",
    boxSizing: "border-box",
    height: "28px",
    marginLeft: "2px",
    marginRight: "2px",
  },
  indicator: {
    display: "none",
  },
}));

export { useTabStyles, useTabsStyles };
